// import Paper from '@mui/material/Paper';
// import Box from '@mui/material/Box';
// import './StickyNote.css'

// export function StickyNote({ note, settings, titleOnClicked }) {
//   const bgcolor = "lightyellow";
//   const width = "75px";
//   const height = "75px";
//   const padding = "8px";
//   const margin = "8px";
//   const sxCommon = {
//           "padding": padding,
//           "margin": margin,
//           "width": width,
//           "height": height,
//           "font-weight": "bold"
//         };
//   const sxNote = {
//           ...sxCommon,
//           "backgroundColor": bgcolor,
//           "wordBreak": "auto-phrase",
//           "wordWrap": "break-word"
//         };
//   const noteElem = (
//     <div className="sticky-note">
//       <Paper elevation={2} sx={sxNote}>
//         <div className="note-title" onClick={titleOnClicked}>
//           <a>{note && note[':']}</a>
//         </div>
//       </Paper>
//     </div>
//   );
//   const emptyElem = (
//     <Box sx={sxCommon}></Box>
//   )

//   return note && note[':'] ? noteElem : emptyElem;
// }

// export default StickyNote;

// export function StickyNote({ note, level, titleOnClicked }) {
//   const bgcolor = level == 0 ? "lightpink" : level == 1 ? "lightblue" : "lightyellow";
//   const width = "100px";
//   const height = "75px";
//   const padding = "8px";
//   const margin = "8px";
//   const sxCommon = {
//           "padding": padding,
//           "margin": margin,
//           "width": width,
//           "height": height
//         };
//   const sxNote = {...sxCommon, "backgroundColor": bgcolor};
//   const noteElem = (
//     <Paper elevation={2} sx={sxNote}>
//       <div className="note">
//         <div className="note-title" onClick={titleOnClicked}>
//           <a>{note && note[':']}</a>
//         </div>
//       </div>
//     </Paper>
//   );
//   const emptyElem = (
//     <Box sx={sxCommon}></Box>
//   )

//   return note && note[':'] ? noteElem : emptyElem;
// }

// export default StickyNote;

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import "./StickyNote.css";

export function StickyNote({ group, userStory, settings, titleOnClicked }) {
  const effectiveSettings = settings.getGroupSettings(group);
  const bgcolor = effectiveSettings.bgcolor;
  const width = effectiveSettings.width;
  const height = effectiveSettings.height;
  const padding = "8px";
  const margin = "8px";
  const sxCommon = {
    padding: padding,
    margin: margin,
    width: width,
    height: height,
    "font-weight": "bold",
  };
  const sxNote = {
    ...sxCommon,
    backgroundColor: bgcolor,
    wordBreak: "auto-phrase",
    wordWrap: "break-word",
  };
  const noteElem = (
    <div className="sticky-note">
      <Paper elevation={2} sx={sxNote}>
        <div className="note-title" onClick={titleOnClicked}>
          <a>{userStory && userStory.title}</a>
        </div>
      </Paper>
    </div>
  );
  const emptyElem = <Box sx={sxCommon}></Box>;

  return userStory && userStory.title ? noteElem : emptyElem;
}

export default StickyNote;
